import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ConfirmFirstPurchaseParams } from "../../../domain/repos/first-purchase-repo";
import { type FirstPurchaseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const confirmFirstPurchase = createAsyncThunk<
  void,
  ConfirmFirstPurchaseParams,
  { dispatch: FirstPurchaseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CONFIRM_FIRST_PURCHASE, async (params, { extra }) => {
  await extra.firstPurchaseRepo.confirmFirstPurchase(params);
});
